import { render, staticRenderFns } from "./QuickTipsPersonMatchOptionsUpload.vue?vue&type=template&id=30208ab5&scoped=true&"
import script from "./QuickTipsPersonMatchOptionsUpload.vue?vue&type=script&lang=js&"
export * from "./QuickTipsPersonMatchOptionsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30208ab5",
  null
  
)

export default component.exports